import { render, staticRenderFns } from "./ViewerImage.vue?vue&type=template&id=384043d7&"
import script from "./ViewerImage.vue?vue&type=script&lang=js&"
export * from "./ViewerImage.vue?vue&type=script&lang=js&"
import style0 from "./ViewerImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports